import { useState } from "react";
import { KeyRound, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import ChangePasswordDialog from "./ChangePasswordDialog";

export default function AdminShell({ children }) {
  const { user, logout } = useAuth();
  const [pwOpen, setPwOpen] = useState(user?.must_change_password === true);

  return (
    <div className="min-h-screen bg-paper text-ink" data-testid="admin-shell">
      <header className="sticky top-0 z-40 border-b border-black/10 bg-white/85 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-5 lg:px-8">
          <div className="flex items-center gap-4">
            <a href="/" className="font-display text-2xl font-extrabold tracking-tighter" data-testid="admin-logo">
              iogama<span className="text-cobalt">.</span>
            </a>
            <span className="hidden font-mono text-[10px] uppercase tracking-[0.24em] text-ink/40 sm:inline">/ Preventivi ricevuti</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="hidden font-mono text-[10px] uppercase tracking-[0.16em] text-ink/50 md:inline" data-testid="admin-user-name">
              {user?.name}
            </span>
            <button
              onClick={() => setPwOpen(true)}
              className="flex h-9 items-center gap-2 border border-black/15 px-3 font-mono text-[10px] uppercase tracking-[0.16em] text-ink transition-colors hover:border-ink"
              data-testid="admin-change-password-button"
            >
              <KeyRound className="h-3.5 w-3.5" />
              <span className="hidden sm:inline">Password</span>
            </button>
            <button
              onClick={logout}
              className="flex h-9 items-center gap-2 bg-ink px-3 font-mono text-[10px] uppercase tracking-[0.16em] text-white transition-colors hover:bg-cobalt"
              data-testid="admin-logout-button"
            >
              <LogOut className="h-3.5 w-3.5" />
              <span className="hidden sm:inline">Esci</span>
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-5 py-8 lg:px-8 lg:py-12">{children}</main>
      <ChangePasswordDialog open={pwOpen} onClose={() => setPwOpen(false)} forced={user?.must_change_password === true} />
    </div>
  );
}
